export const GET_EOD_REPORTS_LOGS_REQUEST = "GET_EOD_REPORTS_LOGS_REQUEST";
export const GET_EOD_REPORTS_LOGS_SUCCESS = "GET_EOD_REPORTS_LOGS_SUCCESS";
export const GET_EOD_REPORTS_LOGS_FAILURE = "GET_EOD_REPORTS_LOGS_FAILURE";
